import React from "react";
import { Container, Typography, Box, List, ListItem, ListItemIcon, ListItemText, Divider, Alert } from "@mui/material";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faGavel,
    faTriangleExclamation,
    faCircleInfo,
    faUserGroup,
    faTree,
    faCommentDots,
    faHandshake,
    faBullhorn,
} from "@fortawesome/free-solid-svg-icons";
import { faNewspaper } from "@fortawesome/free-regular-svg-icons";

const POST20240626: React.FC = () => (
    <Container sx={{ mb: 5 }}>
        <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />
        <Box mt={3}>
            <Typography
                variant="h6"
                fontWeight={700}
                align="center"
                gutterBottom
                color="primary"
            >
                Bilan des 4 réunions du PLUi
            </Typography>
        </Box>

        <Box mt={4}>
            <Divider sx={{ my: 2 }} />
            <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
                    Sur la méthode <FontAwesomeIcon icon={faGavel} style={{ color: "#1976d2", marginLeft: 6 }} />
                </Typography>
                <Typography sx={{ mb: 1 }}>
                    Le Maire n’a pas associé les habitants à l’élaboration de son projet de PLUi, comme il aurait dû le faire. Il ne voulait pas communiquer les éléments de ce dossier avant son vote en conseil d'agglomération.
                    Les habitants ont découvert le projet grâce aux documents publiés par les associations et lors des 4 réunions publiques, entre le 15 et le 26 juin, soit moins de deux semaines avant le vote au conseil d’agglomération, le 27 juin 2024.
                </Typography>
                <Alert severity="warning" icon={<FontAwesomeIcon icon={faTriangleExclamation} />}>
                    Nombre d’habitants restent non informés du projet au vu des délais contraints et de la découverte tardive.
                    <b>Merci de relayer cette information à vos voisins !</b>
                </Alert>
                <Typography sx={{ mt: 1 }}>
                    À la question « Les propriétaires spoliés ont-ils été informés ? », le Maire a répondu que cela aurait été trop de travail, se coupant ainsi du dialogue avec les citoyens.<br/>
                    Comme à son habitude (EPFIF 2021, PLH 2023…), il a décidé seul, sans en informer ni les colistiers ni la commune.
                </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
                    Sur le fond <FontAwesomeIcon icon={faTree} style={{ color: "#388e3c", marginLeft: 6 }} />
                </Typography>
                <List dense>
                    <ListItem>
                        <ListItemIcon><FontAwesomeIcon icon={faUserGroup} color="#6a1b9a" /></ListItemIcon>
                        <ListItemText
                            primary="Règle des 80% de logements sociaux dès 3 logements construits (75% dès 16), bien au-delà des obligations légales."
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><FontAwesomeIcon icon={faBullhorn} color="#1976d2" /></ListItemIcon>
                        <ListItemText
                            primary="20 secteurs imposant 80% de logements sociaux dès le premier logement."
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><FontAwesomeIcon icon={faTree} color="#388e3c" /></ListItemIcon>
                        <ListItemText
                            primary="Réglementation favorable à la densification urbaine : emprise au sol, hauteurs, marges, réduction des espaces boisés classés."
                        />
                    </ListItem>
                </List>

                <Typography sx={{ my: 2 }}>
                    <b>Nous refusons</b> la dégradation du PLU actuel et la densification au détriment du patrimoine environnemental et du cadre de vie.
                </Typography>

                <Alert severity="error" icon={<FontAwesomeIcon icon={faTriangleExclamation} />}>
                    Ce PLUi génère une forte contestation et révèle le manque de transparence. Les Bacots, propriétaires ou non, sont solidaires et demandent le respect de leur cadre de vie.
                </Alert>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
                    Dernière réunion publique <FontAwesomeIcon icon={faCommentDots} style={{ color: "#1976d2", marginLeft: 6 }} />
                </Typography>
                <Typography>
                    Le Maire a refusé de retirer les points de tension, ni d’apaiser la commune. Il a interdit la captation vidéo de la réunion et a empêché certains habitant·e·s de s’exprimer.<br />
                    Il affirme que le PLUi permettra davantage de protections, ce qui est <b>faux</b>. La physionomie de Bois-le-Roi sera radicalement transformée à l’horizon 2030.
                </Typography>
                <Typography sx={{ mt: 1, color: "text.secondary" }}>
                    Après le vote, les habitants seront devant le fait accompli. La consultation prévue en mars 2025 n’apportera que des modifications à la marge.
                </Typography>
                <Typography sx={{ mt: 1 }}>
                    Nous renouvelons notre <b>demande</b> :
                </Typography>
                <Alert severity="info" icon={<FontAwesomeIcon icon={faHandshake} />}>
                    <b>Nomination d’un MÉDIATEUR indépendant</b> pour accompagner Bois-le-Roi vers un projet de PLUI réellement concerté, dans l’intérêt général.
                </Alert>
            </Box>
        </Box>
    </Container>
);

export default POST20240626;